package org.hs_soft.runmynesto.pages.home.sub_page.template.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.grid_function.FilterActiveGridContent
import org.hs_soft.runmynesto.pages.components.grid_function.GridFunction
import org.hs_soft.runmynesto.pages.components.grid_function.GridItemsList
import org.hs_soft.runmynesto.pages.components.FilterRow


@Composable
fun GridTemplateBar(
    infoList: List<TemplateCategoryModel>,
    selectedItem: GetCategory?,
    titleDescending: Boolean,
    selectedFilterOption: GridItemsFilterEnum,
    showFilterComponent: Boolean,
    numberDescending: Boolean = false,
    showNumberSortIcon: Boolean = false,
    loading:Boolean=false,
    showTitleSortIcon: Boolean,
    windowSizeMode: WindowSizeModeEnum,
    onAddRecord: () -> Unit,
    onNumberSortClick: () -> Unit = {},
    onTitleSortClick: () -> Unit,
    onRefreshUserList: () -> Unit,
    updateListAfterDragAndDrop: (List<dynamic>, List<String>, List<Int>) -> Unit,
    onCategoryClick: (String) -> Unit,
    selectFilterType: (GridItemsFilterEnum) -> Unit,
    onCloseFilterClick: () -> Unit,
    submitFilterItems: () -> Unit,
    onFilterComponentClick: () -> Unit,
    onSwipeRight: () -> Unit,

) {

    Column(
        modifier = Modifier
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
            .fillMaxHeight()
    )
    {


        FilterRow(
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            selectedFilterType = selectedFilterOption,
            onAddRecordClick = {
                onAddRecord()
            },
            onFilterClick = {
                onFilterComponentClick()
            },
        )

        Box(
            modifier = Modifier
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .weight(1f)
                .margin(
                    bottom = Dimen.normalPadding,
                    top = Dimen.smallPadding,
                )
        )
        {
            if (showFilterComponent){

                FilterActiveGridContent(
                    selectFilterType = {
                        selectFilterType(it)
                    },
                    selectedFilterType=selectedFilterOption,
                    onCloseFilterClick ={
                        onCloseFilterClick()
                    },
                    submitFilterItems = {
                        submitFilterItems()
                    }

                )
            }

            GridFunction(
                modifier = Modifier
                    .margin(top = Dimen.normalPadding),
                title = Strings.current().name,
                fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                infoTitle ="",
                loading = false,
                footerTitle = Strings.current().template,
                infoList = infoList,
                onTitleSortClick = {
                    onTitleSortClick()
                },
                onNumberSortClick = {
                    onNumberSortClick()
                },
                refreshList = {
                    onRefreshUserList()
                },
                content = {
                    GridItemsList(
                        id=selectedItem?.id?:"",
                        items = infoList,
                        onItemClick = {
                            onCategoryClick(it)
                        },
                        onReorder = {newList,idList,positionList,itemIdList->
                            updateListAfterDragAndDrop(
                                newList,
                                idList,
                                positionList,
                            )
                        },
                    )
                },
                titleDescending = titleDescending,
                numberDescending = numberDescending,
                showTitleSortIcon = showTitleSortIcon,
                showNumberSortIcon = showNumberSortIcon,
            )
        }



    }
}